import { createFileRoute, redirect } from "@tanstack/react-router";
import { GET_STARTED } from "@/features/shell/workspaceNav";
import { workspaceQuery } from "@/lib/api/queries";
import { useUiStore } from "@/lib/stores/ui";

/**
 * Workspace index opens the last project the user visited, else the first one. A workspace with
 * no projects yet opens Get started.
 */
export const Route = createFileRoute("/w/$workspace/")({
  beforeLoad: async ({ context, params }) => {
    const { projects } = await context.queryClient.ensureQueryData(
      workspaceQuery(params.workspace),
    );
    const remembered = useUiStore.getState().lastProject[params.workspace];
    const target = projects.find((p) => p.slug === remembered) ?? projects[0];
    if (!target)
      throw redirect({
        to: "/w/$workspace/$section",
        params: { workspace: params.workspace, section: GET_STARTED },
      });
    throw redirect({
      to: "/w/$workspace/p/$project",
      params: { workspace: params.workspace, project: target.slug },
    });
  },
});
